import React from 'react'
import Region from '../../../shared/components/region'
import classNames from 'classnames'
import { CSSTransition } from 'react-transition-group'
import SVG from 'react-inlinesvg'
import { SHARED_BUTTON_CLASSNAMES } from './buttons'
import calendarIcon from '../../../../images/calendar-simple.svg'
import DatePicker from '../date-picker'
import scrolling from '../../../utils/scrolling'
import './calendar-dropdown.css'

export default class DatePickerButton extends React.Component {
  rootRef = React.createRef()
  buttonRef = React.createRef()
  datePickerRootRef = React.createRef()

  state = {
    open: false
  }

  // make sure body scrolling is disabled when calendar is open
  componentDidUpdate() {
    if (window.matchMedia('(max-width: 45em)').matches) {
      if (this.state.open && !scrolling.locked) {
        scrolling.lock()
      } else if (!this.state.open && scrolling.locked) {
        scrolling.unlock()
      }
    }
  }

  render() {
    let { dateRange } = this.props

    return (
      <Region
        innerRef={this.rootRef}
        onEscape={this.handleEscape}
        onFocusOut={this.handleFocus}
        onClickOutside={this.handleClickOutside}
        onKeyDown={this.handleKeyDown}
        className={classNames('md:relative sm:ml-auto sm:mr-8 lg:mx-8', {
          'date-range': dateRange.isRange(),
          'date-day': dateRange.isSingleDay()
        })}
      >
        <button
          type="button"
          ref={this.buttonRef}
          data-testid="calendar"
          onClick={this.toggleDatePicker}
          className={classNames(SHARED_BUTTON_CLASSNAMES, 'px-12 leading-none')}
        >
          <SVG
            src={calendarIcon}
            aria-hidden="true"
          />
          <span className="sr-only">
            Go to Specific {dateRange.isSingleDay() ? 'Day' : 'Week'}
          </span>
        </button>

        {this.renderDatePicker()}
      </Region>
    )
  }

  renderDatePicker() {
    let { dateRange, navigate, fromTicketsApp } = this.props

    return (
      <CSSTransition
        nodeRef={this.rootRef}
        in={this.state.open}
        timeout={0}
        classNames="calendar-dropdown"
        unmountOnExit
      >
        <DatePicker
          fromTicketsApp={fromTicketsApp}
          navigate={navigate}
          dateRange={dateRange}
          innerRef={this.datePickerRootRef}
          onDismiss={this.hideDatePicker}
        />
      </CSSTransition>
    )
  }

  handleKeyDown = e => {
    if (!this.state.open && e.key === 'ArrowDown') {
      this.toggleDatePicker()
      e.preventDefault()
    }
  }

  // hide the datepicker when focus leaves it's container
  handleFocus = e => this.hideDatePickerAndRestoreFocus(e)

  // handle outside clicks, close datepicker
  handleClickOutside = e => this.hideDatePickerAndRestoreFocus(e)

  // handle ESC to close datepicker
  handleEscape = e => this.hideDatePickerAndRestoreFocus(e)

  hideDatePickerAndRestoreFocus = e => {
    if (this.state.open) {
      this.hideDatePicker()
      e.preventDefault()
      e.stopPropagation()
    }
  }

  toggleDatePicker = () => {
    this.setState(({ open }) => ({ open: !open }))
  }

  hideDatePicker = () => {
    this.setState({ open: false })
  }
}
